import {has} from 'lodash';
import React from 'react';
import {getFeatureInteraction} from 'shared/actions/feature-interactions';
import Banner from 'src/components/banner';
// next-steps-modal
import {BANNER_MESSAGES, INTERACTION_NAME} from '../constants';

class NextStepsBanners extends React.Component {
  state = {bannerType: null};

  componentDidMount() {
    getFeatureInteraction(INTERACTION_NAME, 'dismissed_by')
      .then((data) => {
        this.setState({
          bannerType: data && data.dismissedBy,
        });
      })
      .catch(() => {});
  }

  hideBanner = () => this.setState({bannerType: null});

  render() {
    if (has(BANNER_MESSAGES, this.state.bannerType)) {
      return (
        <Banner
          {...BANNER_MESSAGES[this.state.bannerType]}
          dismiss={this.hideBanner}
          linkHandler={this.hideBanner}
        />
      );
    } else {
      return null;
    }
  }
}

export default NextStepsBanners;
